import { createRouter, createWebHistory } from 'vue-router'
import Analysis from '../pages/Analysis.vue'
import LandingLeadGen from '../pages/LandingLeadGen.vue'
import { useBranding } from '@/composables/useBranding'

// Layouts
import DefaultLayout from '../layouts/default.vue'
import EmbedLayout from '../layouts/embed.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: LandingLeadGen,
    meta: { gtm: 'TTB home', layout: DefaultLayout },
  },
  {
    path: '/analysis',
    name: 'Analysis',
    component: Analysis,
    meta: { gtm: 'TTB analysis', layout: DefaultLayout },
  },
  {
    path: '/embed',
    name: 'Embed',
    component: LandingLeadGen,
    meta: { gtm: 'TTB embed', layout: EmbedLayout },
  },
  {
    path: '/results',
    name: 'Results',
    component: Analysis,
    meta: { gtm: 'TTB analysis', layout: EmbedLayout },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

router.beforeEach(async (to) => {
  const { loadBranding } = useBranding()
  await loadBranding({ query: to.query })
})

export default router
